// Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
// See LICENSE in the project root for license information.

export const PLUGIN_NAME: 'sass-plugin' = 'sass-plugin';
